import { PaymentMethodType } from "../types/enums/PaymentMethodType";
import { PaymentProvider } from "../types/enums/PaymentProvider";

const providerByPaymentMethodType: Partial<
  Record<PaymentMethodType, PaymentProvider>
> = {
  [PaymentMethodType.SOFTPAY]: PaymentProvider.SOFTPAY,
  [PaymentMethodType.WESTPAY_CLOUD]: PaymentProvider.WESTPAY,
  [PaymentMethodType.MARKETPAY_CLOUD]: PaymentProvider.MARKETPAY,
  [PaymentMethodType.MARKETPAY_LOCAL]: PaymentProvider.MARKETPAY,
  [PaymentMethodType.MARKETPAY_SDK]: PaymentProvider.MARKETPAY,
  [PaymentMethodType.VIVA]: PaymentProvider.VIVA,
  [PaymentMethodType.VIVA_CLOUD]: PaymentProvider.VIVA,
  [PaymentMethodType.VIVA_SMART_CHECKOUT]: PaymentProvider.VIVA,
  [PaymentMethodType.NETS_TERMINAL]: PaymentProvider.NETS,
};

const meteredPaymentProviders: PaymentProvider[] = [PaymentProvider.SOFTPAY];

const terminalLicenseExemptProviders: PaymentProvider[] = [
  PaymentProvider.SOFTPAY,
  PaymentProvider.VIVA,
];

export const mapPaymentMethodTypeToPaymentProvider = (
  paymentMethodType: PaymentMethodType,
): PaymentProvider | null => {
  return providerByPaymentMethodType[paymentMethodType] ?? null;
};

export const isMeteredPaymentProvider = (
  paymentProvider: PaymentProvider,
): boolean => {
  return meteredPaymentProviders.includes(paymentProvider);
};

export const isLicensedPaymentProvider = (
  paymentProvider: PaymentProvider,
): boolean => {
  return !terminalLicenseExemptProviders.includes(paymentProvider);
};
